'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_split_DuplicateKeysConfig(_shouldWarn) {
  this.uZ = false;
  this.uZ = _shouldWarn;
}
export { $c_Lcom_raquo_airstream_split_DuplicateKeysConfig as $c_Lcom_raquo_airstream_split_DuplicateKeysConfig };
$p = $c_Lcom_raquo_airstream_split_DuplicateKeysConfig.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_split_DuplicateKeysConfig;
/** @constructor */
function $h_Lcom_raquo_airstream_split_DuplicateKeysConfig() {
}
export { $h_Lcom_raquo_airstream_split_DuplicateKeysConfig as $h_Lcom_raquo_airstream_split_DuplicateKeysConfig };
$h_Lcom_raquo_airstream_split_DuplicateKeysConfig.prototype = $p;
var $d_Lcom_raquo_airstream_split_DuplicateKeysConfig = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_split_DuplicateKeysConfig, "com.raquo.airstream.split.DuplicateKeysConfig", ({
  h7: 1
}));
export { $d_Lcom_raquo_airstream_split_DuplicateKeysConfig as $d_Lcom_raquo_airstream_split_DuplicateKeysConfig };
